import {Component, OnInit, HostBinding, input} from '@angular/core';
import { MatMenuPanel, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { AvatarComponent } from '@exl-ng/mulo-common';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'exl-user-menu-button',
    templateUrl: './user-menu-button.component.html',
    styleUrls: ['./user-menu-button.component.scss'],
    host: { 'class': 'exl-user-menu-button' },
    imports: [MatButton, MatMenuTrigger, AvatarComponent, MatIcon, TranslateModule]
})
export class UserMenuButtonComponent implements OnInit {

    readonly avatar = input<string>(undefined);
    readonly userName = input<string>(undefined);
    readonly userInitials = input<string>(undefined);
    readonly proxyAvatar = input<string>(undefined);
    readonly proxyName = input<string>(undefined);
    readonly proxyInitials = input<string>(undefined);
    readonly userMatMenu = input<MatMenuPanel>(undefined);

    @HostBinding('class.has-proxy') get hasProxy(){
        const proxyName = this.proxyName();
        return proxyName ? proxyName.length : '';
    }

    constructor() { }

    ngOnInit() {
    }

}
